import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import CouponsList from './couponsList';
import style from '@/views/components/productManager/style.vue';
@Component({
  mixins: [style],
  components: {
    CouponsList,
  },
})
export default class CouponsManage extends Vue {
  /**
   * 网点组Id
   * @type {number}
   */
  public sgId = 0;

  /**
   * 网点Id
   * @type {number}
   */
  public siteId = 0;

  /**
   * 状态 9 全部 1 上架中 0 已下架
   * @type {string}
   */
  public curTab = '9';

  /**
   * 排序
   * @type {number}
   */
  public sort = 0;

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 每页显示数量
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 搜索关键字
   * @type {number}
   */
  public keywords = '';

  mounted() {
    this.siteId = +this.$route.params.siteId;
  }

  @Watch('curTab', { deep: true })
  onSwitch(val) {
    this.sort = 0;
    this.keywords = '';
    this.page = 1;
    this.pageSize = 10;
  }

  renderTabPan(h) {
    return (
      <el-container class="categoryConfig" style="height:100%;">
        <el-aside width="100%">
          <el-tabs tab-position="left" class="el-tabs" v-model={this.curTab}>
            <el-tab-pane label="全部" class="el-tab-pane" name="9">
              {this.curTab == '9' && this.renderList(h)}
            </el-tab-pane>
            <el-tab-pane label="上架中" class="el-tab-pane" name="1">
              {this.curTab == '1' && this.renderList(h)}
            </el-tab-pane>
            <el-tab-pane label="已下架" class="el-tab-pane" name="0">
              {this.curTab == '0' && this.renderList(h)}
            </el-tab-pane>
          </el-tabs>
        </el-aside>
      </el-container>
    );
  }

  renderList(h) {
    return (
      <CouponsList
        propSort={this.sort}
        propPage={this.page}
        propPageSize={this.pageSize}
        propKeyword={this.keywords}
        openState={+this.curTab}
        onSortChange={val => (this.sort = val)}
        onPageChange={val => (this.page = val)}
        onPageSizeChange={val => (this.pageSize = val)}
        onKeywordChange={val => (this.keywords = val)}
        siteId={+this.$route.params.siteId}
      />
    );
  }

  render(h) {
    return this.renderTabPan(h);
  }
}
